<template>
  <div>
    <el-card>
      <el-form ref="form" :inline="true">
        <el-form-item label="来源">
          <el-select
            v-model="queryForm.mold"
            placeholder="请选择来源"
            clearable
          >
            <el-option
              :label="item.value"
              :value="item.key"
              v-for="item in moldOptions"
              :key="item.key"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input
            placeholder="请输入手机号"
            v-model="queryForm.phone"
          ></el-input>
        </el-form-item>
         <el-form-item label="订单号">
          <el-input
            placeholder="请输入订单号"
            v-model="queryForm.order_sn"
          ></el-input>
        </el-form-item>
        <el-form-item label="时间">
          <el-date-picker
            type="datetimerange"
            v-model="times"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="toQuery" icon="el-icon-search"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
      <el-table
        :data="integralOrderList"
        stripe
        class="table"
        ref="userTable.multipleSelection"
        header-cell-class-name="table-header"
        border
      >
        <el-table-column
          type="selection"
          width="55"
          align="center"
        ></el-table-column>

        <el-table-column
          prop="id"
          label="ID"
          width="55"
          align="center"
        ></el-table-column>
        <el-table-column label="订单编号" prop="order_sn" align="center"></el-table-column>
        <el-table-column label="联系方式" prop="phone" align="center">
        </el-table-column>
        <el-table-column label="数量" prop="number" align="center">
        </el-table-column>
        <el-table-column label="支付金币" prop="pay_price" align="center">
        </el-table-column>
        <el-table-column label="下单时间" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.create_time !== null">
              {{
                $moment(scope.row.create_time * 1000).format(
                  "YYYY-MM-DD HH:mm:ss"
                )
              }}
            </div>
            <div v-else>空</div>
          </template>
        </el-table-column>
        <el-table-column label="订单来源" prop="mold" align="center">
        </el-table-column>
        
        <el-table-column label="商品状态" prop="order_status" align="center">
        </el-table-column>
   
        <el-table-column label="操作" align="center" >
           <template slot-scope="scope">
            <el-button type="primary" size="small" icon="el-icon-truck" circle @click="toLogistics(scope.row)"></el-button>
            <el-button type="success" size="small" icon="el-icon-info" circle @click="toDetails(scope.row)"></el-button>
          </template>
        </el-table-column>
      </el-table>

       <!-- 分页区域 -->
     <div class="pagination">
       <span></span>
        <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryForm.page"
        :page-sizes="[3, 5, 8, 10]"
        :page-size="queryForm.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        algin:="center"
      ></el-pagination>
     </div>


    <!-- 详情弹框 -->
    <el-dialog
      :visible.sync="detailsDialog"
      title="详情"
      append-to-body
      width="50%"
      :close-on-click-modal="false"
    >
      <el-form :model="detailsData" ref="details">
        <el-form-item el-form-item label="商品名称：" label-width="100px">
          {{detailsData.goods_name}}
        </el-form-item>
        <el-form-item el-form-item label="订单号：" label-width="100px">
          {{detailsData.order_sn}}
        </el-form-item>
        <el-form-item el-form-item label="数量：" label-width="100px">
          {{detailsData.number}}
        </el-form-item>
        <el-form-item el-form-item label="支付金币：" label-width="100px">
          {{detailsData.pay_price}}
        </el-form-item>
        <el-form-item el-form-item label="订单来源：" label-width="100px">
          {{detailsData.mold}}
        </el-form-item>
        <el-form-item el-form-item label="订单时间：" label-width="100px">
           {{$moment(detailsData.create_time * 1000).format("YYYY-MM-DD HH:mm:ss")}}
        </el-form-item>
        <el-form-item el-form-item label="更新时间：" label-width="100px">
           {{$moment(detailsData.update_time * 1000).format("YYYY-MM-DD HH:mm:ss")}}
        </el-form-item>
        <el-form-item el-form-item label="订单状态：" label-width="100px">
          {{detailsData.order_status}}
        </el-form-item>
         <el-form-item el-form-item label="联系方式：" label-width="100px">
          {{detailsData.phone}}
        </el-form-item>
        
      </el-form>
    </el-dialog>


    <!-- 物流弹框 -->
    <el-dialog
      :visible.sync="logisticsDialog"
      title="物流管理"
      append-to-body
      width="50%"
      :close-on-click-modal="false"
      center
      @close="logisticsClose"
    >
      <el-form :model="putGoldOrderData">
        <el-form-item el-form-item label="用户姓名:" label-width="100px">
            <el-input :disabled="isDisable" style="width:200px" v-model="putGoldOrderData.name" placeholder="请输入标题"></el-input>
            <el-button  @click="toDisable" style="margin-left:30px" type="primary" icon="el-icon-edit" circle></el-button>
        </el-form-item>
         <el-form-item  el-form-item label="联系方式:" label-width="100px">
            <el-input :disabled="isDisable" style="width:200px"  v-model="putGoldOrderData.phone" placeholder="请输入标题"></el-input>
            <el-button  @click="toDisable" style="margin-left:30px" type="primary" icon="el-icon-edit" circle></el-button>
        </el-form-item>
        <el-form-item el-form-item label="地址:" label-width="100px">
            <el-input
            style="width:300px" 
            type="textarea"
            :rows="4"
            placeholder="请输入地址"
            :disabled="isDisable"
            v-model="putGoldOrderData.address"
          />
          <el-button @click="toDisable" style="margin-left:30px" type="primary" icon="el-icon-edit" circle></el-button>
        </el-form-item>
         <el-form-item  el-form-item label="物流公司:" label-width="100px">
          <el-select
            v-model="editExpressData.express"
            placeholder="请选择物流公司"
            clearable
            :disabled="!isDisable"
          >
            <el-option
              :label="item.value"
              :value="item.key"
              v-for="item in expressListData"
              :key="item.key"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item el-form-item label="物流单号:" label-width="100px">
            <el-input :disabled="!isDisable" style="width:200px;" v-model="editExpressData.express_num" @input="editExpressData.express_num=editExpressData.express_num.replace(/[^\w\.\/]/ig,'')" placeholder="请输入物流单号"></el-input>
        </el-form-item>
        <el-form-item label-width=40% style="margin-top: 20px;">
           <el-button v-if="isDisable" type="primary" @click="editLogistics">物流发货</el-button>
           <el-button v-else type="warning" @click="editAdress">修改地址</el-button>
        </el-form-item>
      </el-form>

    </el-dialog>

    </el-card>
  </div>
</template>

<script>
import store from "@/store";
import {IntegralOrder,GetExpressList,GoldOrderSend,GoldOrderAddress} from '@/api/points_order.js'
import { warningDialog } from "@/utils/dialog";
import { log } from 'util';

export default {

  data() {
    return {
      queryForm:{
          mold:null,
          page:1,
          limit:10,
          start_time:null,
          end_time:null,
          order_sn:null,
          phone:null
      },
      moldOptions:[{
          value:'官网',
          key:'index'
        },
        {
          value:'日语APP',
          key:'japanese'
        },
        {
          value:'韩语APP',
          key:'korean'
        },
        {
          value:'法语APP',
          key:'french'
        },],
      times:null,                                                                                                                                                           
      integralOrderList:[],
      total:0,
      detailsDialog:false,
      detailsData:{},
      logisticsDialog:false,
      putGoldOrderData:{
        order_sn:null,
        name:'',
        phone:'',
        address:''
      },
      isDisable:true,
      expressListData:[],
      editExpressData:{
        order_sn:null,
        express:'',
        express_num:''
      }
    };
  },

  created(){
      this.getIntegralOrder()
  },
  methods: {
        //   获取积分列表
    getIntegralOrder(){
        IntegralOrder(this.queryForm).then(res=>{
            if (res.code!==1) {
                this.$message.error(res.msg)
                return
            }
           
            this.total=res.data.total
            this.integralOrderList=res.data.data
        })
    },
    handleSizeChange(size) {
        this.queryForm.limit = size;
        this.getIntegralOrder();
    },
    handleCurrentChange(page) {
        this.queryForm.page = page;
        this.getIntegralOrder();
    },

    //  查询
    toQuery(){
        this.queryForm.page=1
        if (this.times) {
            this.queryForm.start_time = new Date(this.times[0]).getTime() / 1000;
            this.queryForm.end_time = new Date(this.times[1]).getTime() / 1000;
        }else if(this.times==null){
            this.queryForm.start_time =null;
            this.queryForm.end_time =null;
        }
        this.getIntegralOrder()
    },

       // 点击详情
    toDetails(item){
        this.detailsData=item
        this.detailsData.nickname=item.user.nickname
        this.detailsData.goods_name=item.userGoldGoods.goods_name
        this.detailsDialog=true
    },

    // 点击物流按钮
     toLogistics(item){
      this.editExpressData.order_sn=item.order_sn
      this.editExpressData.express=item.express
      this.editExpressData.express_num=item.express_num
      this.putGoldOrderData.order_sn=item.order_sn
      this.putGoldOrderData.name=item.name
      this.putGoldOrderData.phone=item.phone
      this.putGoldOrderData.address=item.address
      GetExpressList().then(res=>{
        this.expressListData=res.data
      })
      this.logisticsDialog=true
    },
    // 点击修改物流
    editLogistics(){
      if (this.editExpressData.express=='') {
        this.$message.error('请选择物流公司')
        return
      }else if (this.editExpressData.express_num=='') {
        this.$message.error('请输入物流单号')
        return
      }else if (this.editExpressData.express_num.length>30) {
        this.$message.error('物流单号不能大于30字符')
        return
      }
      GoldOrderSend(this.editExpressData).then(res=>{
        if (res.code!==1) {
          this.$message.error(res.msg)
          return
        }
        this.$message.success('发货成功')
      })
    },

    // 点击切换是否修地址信息
    toDisable(){
      this.isDisable=!this.isDisable
    },

    // 点击立即修改地址
    editAdress(){
      if (this.putGoldOrderData.name=='') {
        this.$message.error('请输入用户姓名')
        return
      }else if (this.putGoldOrderData.phone=='') {
        this.$message.error('请输入用户联系方式')
        return
      }else if (this.putGoldOrderData.address=='') {
        this.$message.error('请输入地址')
        return
      }
      GoldOrderAddress(this.putGoldOrderData).then(res=>{
        if (res.code!==1) {
          this.$message.error(res.msg)
          return
        }
        this.$message.success('修改信息成功!')
      })
    },

    // 物流地址修改弹框关闭事件
    logisticsClose(){
       this.putGoldOrderData={
        order_sn:null,
        name:'',
        phone:'',
        address:''
      },
      this.isDisable=true,
      this.editExpressData={
        order_sn:null,
        express:'',
        express_num:''
      }
      this.getIntegralOrder()
    },
   

  },
  
};
</script>

<style scoped>
.handle-box {
  margin-bottom: 20px;
}

.handle-select {
  width: 120px;
}

.handle-input {
  width: 300px;
  display: inline-block;
}

.table {
  width: 100%;
  font-size: 14px;
}

.red {
  color: #ff0000;
}

.mr10 {
  margin-right: 10px;
}

.table-td-thumb {
  display: block;
  margin: auto;
  width: 40px;
  height: 40px;
}

.add {
  position: fixed;
  /*align-self: flex-end;*/
  right: 130px;
}

.refresh {
  /* position: fixed; */
  /*align-self: flex-end;*/
  /* right: 80px; */
  float: right;
}

.edit {
  margin-left: 50px;
  width: 100px;
  margin-top: 30px;
}

.editUserItemLeft {
  padding-left: 15px;
  margin-top: 5px;
}

.editUserItem {
  margin-bottom: 10px;
  padding-left: 15px;
}
.el-tag {
  cursor: pointer;
}
.pagination {
  display: flex;
  justify-content: space-between;
}
.detail-box{
  height: 750px;
}
.detail{
  width: 100%;
  height: 80px;
  display: flex;
  margin-bottom: 30px;
}
.detail .detail-img{
  flex: 2;
}
.detail-img img{
  width: 82px;
  height: 82px;
  border-radius: 50%;
}
.detail .detail-one{
  flex: 4;
}
.detail .detail-two{
  flex: 5;
}
.detail .detail-three{
  flex: 3;
}
.detail p{
  line-height: 28px;
  color: #323232;
  font-size: 16px;
  font-weight: 500;
}
.detail-box .tabs{
  border-bottom: 2px solid #38A28A;
}
.detail-box .tabs .el-button{
  width: 160px;
  height: 50px;
  border-radius: 0;
}
.detail-box .detail-content{
  height: 504px;
  background-color: #F0F0F0;
}
.jurisdiction{
  height: 700px;
  border-top: 1px solid #ccc;
}
.jurisdiction .jurisdiction-content{
  height: 600px;
  overflow: auto;
}
.jurisdiction .jurisdiction-confirm{
  text-align: center;
  height:100px;
  line-height: 100px;
  margin: auto;
  border-top: 1px solid #ccc;
}
.jurisdiction .jurisdiction-confirm .el-button{
  width: 90px;
  height: 40px;
}
.desc{
    width: 180px;
    height: 112px;
    overflow: hidden;
}
.desc img{
  width: 100%;
  height: 100%;
}
.generate {
  float: right;
}
.file-name{
  /* display: inline-block; */
  width: 100%;
  margin-left: 10px;
  margin-right: 20px;
  white-space: nowrap;
	overflow: hidden;
}
.imgSelect img{
  width: 300px;
  height: 200px;
  cursor: pointer;

}
.videoSelect video{
  width: 300px;
  height: 200px;
  cursor: pointer;
}
::v-deep .el-pager li.active{
  color: #FF6688;
}
</style>
